import {css} from '@emotion/react'

export const Section = () => css`
  * {
    z-index: 1;
  }
`
